export default {
    'UNAVAILABILITIES.TITLE': 'No unavailability scheduled',
    'UNAVAILABILITIES.ASIDE': 'Add your first unavailability in your calendar',
    'UNAVAILABILITIES.BUTTON.TEXT': 'Add my first unavailability',
};
